export enum ConfigurableKeys {
  REPS = 'REPS',
  TIME = 'TIME',
  RPE = 'RPE',
  TEMPO = 'TEMPO',
  HEART_RATE = 'HEART_RATE',
  HEART_RATE_ZONE = 'HEART_RATE_ZONE',
  HEART_RATE_PERCENT_MAX = 'HEART_RATE_PERCENT_MAX',
  DISTANCE = 'DISTANCE',
  FLOORS = 'FLOORS',
  INCLINE = 'INCLINE',
  SPEED = 'SPEED',
  WEIGHT = 'WEIGHT',
  CADENCE = 'CADENCE',
  PACE = 'PACE',
  POWER = 'POWER',
  LEVEL = 'LEVEL',
  COLOR = 'COLOR',
}

// On BE, will we store the value as text or number:
export enum ConfigurableType {
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
}
// For FE to know how to show config value:
export enum ConfigurableFormat {
  TIME = 'TIME',
  NUMBER = 'NUMBER',
  DECIMAL1 = 'DECIMAL1',
  DECIMAL2 = 'DECIMAL2',
  DECIMAL3 = 'DECIMAL3',
  TEMPO = 'TEMPO',
  RANGE = 'RANGE',
  COLOR = 'COLOR',
}
